import { SupportQR, CopyAccount } from './SupportQR';
import { cx } from '../lib/cx';
import styles from './SupportCorner.module.css';

export interface SupportCornerProps {
  /**
   * `landing` — nenápadně vpravo dole se stručným textem (jako v první designové verzi).
   * `app` — ještě decentnější: menší, nižší opacita, text až na hover, na mobilu skryto.
   */
  context?: 'landing' | 'app';
}

/**
 * Plovoucí QR platba pro podporu vývoje — fixně vpravo dole.
 * Port chování z frontend/index.html:2811 (#landing-qr-wrap, opacity 0.6 → 1 na hover).
 */
export function SupportCorner({ context = 'landing' }: SupportCornerProps) {
  const isApp = context === 'app';
  return (
    <div
      className={cx(styles.wrap, isApp && styles.app)}
      aria-label="QR platba na podporu vývoje aplikace"
    >
      <div className={styles.label}>
        <div className={styles.labelHead}>☕ Podpořte vývoj</div>
        {!isApp && (
          <div className={styles.labelText}>
            Ušetřila vám aplikace čas? Příspěvek přes QR kód je vítaný.
          </div>
        )}
        <CopyAccount justify="end" compact />
      </div>
      <SupportQR variant="compact" size={isApp ? 56 : 72} />
    </div>
  );
}
